import { useMemo } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPencil } from '@fortawesome/pro-solid-svg-icons/faPencil';
import { Button, Tabs } from 'src/components/design-system';
import { NotFound } from 'src/components/common';
import {
  TAB_KEYS,
  useQualityMetricsManagementContext,
} from '../quality-metrics-management.context';
import { ManagementOverviewTab } from './management-overview-tab';
import { ManagementResourcesTab } from './management-resources-tab';
import { ManagementDefinitionTab } from './management-definition-tab';
import styles from '../quality-metrics-management.module.scss';

export function ManagementDetailPanel({ onEdit }) {
  const { selectedMetric, selectedTab, setSelectedTab, lang, metricLang } =
    useQualityMetricsManagementContext();

  const tabItems = useMemo(() => {
    if (!selectedMetric) return [];

    // Unlike the clinician panel, Resources and Definition are always present —
    // an empty metric is exactly the one an admin opens in order to fill it.
    return [
      {
        key: TAB_KEYS.OVERVIEW,
        label: metricLang.TAB_OVERVIEW,
        children: <ManagementOverviewTab />,
      },
      {
        key: TAB_KEYS.RESOURCES,
        label: metricLang.TAB_RESOURCES,
        children: <ManagementResourcesTab />,
      },
      {
        key: TAB_KEYS.DEFINITION,
        label: metricLang.TAB_DEFINITION,
        children: <ManagementDefinitionTab />,
      },
    ];
  }, [selectedMetric, metricLang]);

  if (!selectedMetric) {
    return (
      <div className={styles.panel}>
        <NotFound />
      </div>
    );
  }

  return (
    <div className={styles.panel}>
      <div className={styles.panelHeader}>
        <h2 className={styles.panelTitle}>{selectedMetric.title}</h2>
        <Button type="default" onClick={() => onEdit(selectedMetric)}>
          <FontAwesomeIcon icon={faPencil} /> {lang.EDIT_METRIC}
        </Button>
      </div>

      <Tabs activeKey={selectedTab} onChange={setSelectedTab} items={tabItems} destroyOnHidden />
    </div>
  );
}
